<template>
  <el-drawer title="作品评论" :visible="visible" size="68%" @close="close">
    <div class="body" v-loading="loading">
      <el-descriptions v-if="item" :column="1" border size="small">
        <el-descriptions-item label="作品">{{ item.title || item.source_id }}</el-descriptions-item>
        <el-descriptions-item label="平台">{{ platformName(item.platform) }}</el-descriptions-item>
      </el-descriptions>
      <div class="toolbar">
        <span class="summary">已采集 {{ comments.length }} 条一级评论</span>
        <el-button type="primary" plain size="small" :loading="refreshing" @click="refresh">刷新评论</el-button>
      </div>
      <el-table :data="comments" empty-text="暂未采集到评论，可点击“刷新评论”补采集" class="comments-table">
        <el-table-column label="评论人" width="140">
          <template slot-scope="scope">{{ scope.row.author_name || scope.row.author_id || '-' }}</template>
        </el-table-column>
        <el-table-column label="评论内容" min-width="280">
          <template slot-scope="scope"><div class="comment-content">{{ scope.row.content }}</div></template>
        </el-table-column>
        <el-table-column label="点赞" width="80" align="right">
          <template slot-scope="scope">{{ number(scope.row.like_count) }}</template>
        </el-table-column>
        <el-table-column label="评论时间" width="165">
          <template slot-scope="scope">{{ formatDate(scope.row.published_at) }}</template>
        </el-table-column>
        <el-table-column label="首次发现" width="165">
          <template slot-scope="scope">{{ formatDate(scope.row.first_collected_at) }}</template>
        </el-table-column>
        <el-table-column label="最近确认" width="165">
          <template slot-scope="scope">{{ formatDate(scope.row.last_collected_at) }}</template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'

export default {
  props: ['visible', 'item'],
  data () { return { loading: false, refreshing: false, comments: [] } },
  watch: {
    visible (value) {
      if (value && this.item) this.load()
    }
  },
  methods: {
    async load () {
      if (!this.item) return
      this.loading = true
      try {
        this.comments = (await yuqingApi.get(`creator-content/${this.item.id}/comments?limit=200`)).comments || []
      } catch (error) {
        this.$message.error(error.message || '评论加载失败')
      } finally {
        this.loading = false
      }
    },
    async refresh () {
      if (!this.item || this.refreshing) return
      this.refreshing = true
      try {
        const result = await yuqingApi.post(`creator-content/${this.item.id}/comments/refresh`, {})
        const summary = result.comment_collection || {}
        this.$message.success(`评论采集完成，写入 ${summary.saved || 0} 条评论`)
        await this.load()
      } catch (error) {
        this.$message.error(error.message || '评论采集失败')
      } finally {
        this.refreshing = false
      }
    },
    close () {
      this.comments = []
      this.$emit('update:visible', false)
    },
    number (value) { return Number(value || 0).toLocaleString('zh-CN') },
    formatDate (value) { return value ? String(value).replace('T', ' ').slice(0, 16) : '-' },
    platformName (value) { return { douyin: '抖音', bilibili: 'B站', xiaohongshu: '小红书', wechat_channels: '视频号' }[value] || value || '-' }
  }
}
</script>

<style scoped>
.body { padding: 0 20px 20px }
.toolbar { display: flex; justify-content: space-between; align-items: center; margin: 16px 0 10px }
.summary { color: #606266; font-size: 13px }
.comments-table { width: 100% }
.comment-content { white-space: pre-wrap; word-break: break-word; line-height: 20px; }
</style>
